var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettlor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 171.526 237.183",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M34.733 28.813c-.325-.73-1.005-1.566-1.899-2.455a8.013 8.013 0 0 0 .47 7.016c2.033-1.595 2.288-2.625 1.429-4.561zM155.229 56.968c-5.589-5.252-11.05-6.171-13.876-6.244-.172-.011-.342-.026-.517-.026h-8.594c1.346 7.665 4.677 30.409-2.304 34.916l-1.201.774-3.192-23.516c-1.295.486-2.658.74-4.021.74h-.008a11.47 11.47 0 0 1-4.027-.739l-3.191 23.515-1.202-.774c-6.978-4.506-3.649-27.251-2.304-34.916h-7.755c-4.947-.957-33.27-7.042-53.806-24.063-.576.627-1.057 1.239-1.367 1.823-.473.889-1.578 2.97-1.429 3.456.179.579 1.742 1.857 3.553 3.336l.426.348c1.317 1.078 3.285 2.182 5.564 3.461 6.811 3.823 16.139 9.059 23.531 21.295.113.186.212.378.319.566a163.764 163.764 0 0 0 14.644 4.279v159.619c0 6.83 5.537 12.363 12.363 12.363 6.828 0 12.365-5.533 12.365-12.363v-90.272h4.635v90.272c0 6.83 5.537 12.363 12.363 12.363 6.828 0 12.365-5.533 12.365-12.363V74.793c4.47 9.298 8.452 28.029 6.397 63.166a8 8 0 0 0 7.994 8.467 8 8 0 0 0 7.979-7.533c2.474-42.247-2.811-69.811-15.704-81.925z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 121.519,
    cy: 22.5,
    r: 22.5,
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.109 58.654a8.444 8.444 0 0 0 10.82-.004l.289-.456-1.9-7.5h-7.6l-1.9 7.5zM48.959 37.379c-5.5-4.5-5.958-4.667-3.125-10s14.167-10.583 14.5-16-25.625-12.25-20.875-3.75-18.875-4.75-22.625-.25 17 13.75 20 20.5-4.625 8-11.625 14-15.833 11.5-21.333 22.166c-4.784 9.277-.617 31.028.55 36.539l-3.324 3.973a4.764 4.764 0 0 0 .596 6.691 4.765 4.765 0 0 0 6.691-.595l3.181-3.802c5.934 3.318 15.833 6.995 30.14 6.528 13.188-.431 21.418-3.358 26.301-6.084l3.437 4.108a4.763 4.763 0 0 0 6.691.595 4.764 4.764 0 0 0 .596-6.691l-3.764-4.5c2.632-5.687 10.791-25.661 2.573-39.262-9.668-16-23.085-19.666-28.585-24.166zm-6.268 53.978v3.739h-3.728v-3.739c-4.01-.345-7.668-1.968-10.552-4.674l4.854-3.197c3.024 2.607 4.924 3.443 7.878 3.443 3.025 0 4.925-1.525 4.925-3.936 0-1.328-.704-2.607-1.899-3.591-1.196-.935-1.899-1.329-6.05-3.395-6.894-3.444-9.074-5.805-9.074-9.79 0-4.525 3.869-7.871 9.919-8.51v-3.05h3.728v3.05c3.658.295 6.753 1.476 9.496 3.64l-4.854 3.345c-1.899-1.82-3.798-2.558-6.331-2.558-3.165 0-5.135 1.427-5.135 3.739 0 1.279.633 2.46 1.829 3.345 1.055.787 1.548 1.033 5.557 2.952 7.527 3.69 9.849 6.199 9.849 10.577-.001 4.871-3.8 8.02-10.412 8.61z",
    fill: "#868689",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettlor);
export default __webpack_public_path__ + "static/media/settlor.ec94a3eaeee00b6caea6e4eb28bbec95.svg";
export { ForwardRef as ReactComponent };